import { clientePedido } from '../../apiClient/index'

function initialState () {
  return {
    filtrosArchivos: undefined
  }
}
const moduloArchivos = {
  namespaced: true,
  state: initialState,
  actions: {
    
    getArchivos(context, payload) 
    {   
      return new Promise((resolve) => {
        clientePedido.get('/api/Archivo/FindArchivos', { params: payload })

      .then(response => resolve(response.data))
      })
    },

    getArchivosNoVencidos(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Archivo/FindArchivosNoVencidos', { params: payload })
      .then(response => resolve(response.data))
      })
    },

    getArchivo(context, payload) {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Archivo/Get', {params: payload})
        .then(response => resolve(response.data))
      })
    },

    getJerarquiaCarpetas() {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Archivo/GetJerarquiaCarpetas')
        .then(response => resolve(response.data))
      })
    },

    downloadFile(context, payload) {
      return new Promise((resolve,reject)=> {
        clientePedido.get(`/api/Archivo/DownloadFile?idUsuario=${payload.idUsuario}&idPerfiles=${payload.idPerfiles}&id=${payload.idNodo}`,{ responseType: 'arraybuffer' })
        .then(response => resolve(response))
        .catch(response => reject(response))
      })
    },
    getLink(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.get('/api/Archivo/GetLink', {params: payload}).then(response => {
          resolve(response.data)
        })
        .catch(error => reject(error))
      })
    },

    uploadArchivo(context, payload) {             
      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/Archivo/UploadArchivo?id=${payload.id}`, formData)
        .then(          
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
      
    },
    saveArchivo(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Archivo/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    },
    setFiltrosArchivos(context, payload) {
      // guardo los filtros aplicados      
      context.commit('setFiltrosArchivos', payload)
    },
    eliminar(context, payload)
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/Archivo/Eliminar?id=${payload.id }`)
        .then(response => {
          resolve(response.data)
        })
      })
    },
    getArchivosJerarquia(context, payload)
    {
      return new Promise((resolve, reject)=>{
        clientePedido.get(`/api/Archivo/GetJerarquia?idUsuario=${payload.idUsuario}&idPerfiles=${payload.idPerfiles}&idNodo=${payload.idNodo}`)
        .then(response => 
          resolve(response.data))
        .catch(() => reject());
      })
    }
  },
  mutations: {
    setFiltrosArchivos(state, payload) {
      state.filtrosArchivos = payload
    }
  }
}

export default moduloArchivos